/**
 * 加载CSS
 *
 * @author yusangeng@outlook.com
 */
import { CacheStatus } from '../cache/cache';
import cache from '../cache/css';
function installACSS(url) {
    var item = cache.getOrCreateItemByURL(url);
    var status = item.status, error = item.error;
    if (status === CacheStatus.LOADED) {
        return Promise.resolve();
    }
    if (status === CacheStatus.ERROR) {
        return Promise.reject(error);
    }
    if (status === CacheStatus.LOADING) {
        return new Promise(function (resolve, reject) {
            var el = item.el;
            var loadCallback = function () {
                el.removeEventListener('load', loadCallback);
                resolve();
            };
            var errorCallback = function (evt) {
                el.removeEventListener('error', errorCallback);
                reject(evt.error);
            };
            el.addEventListener('load', loadCallback);
            el.addEventListener('error', errorCallback);
        });
    }
    item.status = CacheStatus.LOADING;
    return new Promise(function (resolve, reject) {
        var el = document.createElement('link');
        el.rel = 'stylesheet';
        el.href = url;
        var loadCallback = function () {
            el.removeEventListener('load', loadCallback);
            item.status = CacheStatus.LOADED;
            item.el = null;
            resolve();
        };
        var errorCallback = function (evt) {
            el.removeEventListener('error', errorCallback);
            var error = evt.error || new Error("Load css failed. href=".concat(url));
            item.status = CacheStatus.ERROR;
            item.error = error;
            item.el = null;
            reject(error);
        };
        el.addEventListener('load', loadCallback);
        el.addEventListener('error', errorCallback);
        item.el = el;
        document.head.appendChild(el);
    });
}
function uninstallACSS(url) {
    var item = cache.tryGetItemByURL(url);
    if (!item || !item.el) {
        return Promise.resolve();
    }
    if (item.status === CacheStatus.LOADING) {
        return Promise.reject(new Error("Can NOT uninstall a loading css file."));
    }
    document.head.removeChild(item.el);
    return Promise.resolve();
}
export function installCSS(urls) {
    return Promise.all(urls.map(function (url) { return installACSS(url); }))
        .then(function () {
        return Promise.resolve();
    })
        .catch(function (err) {
        return Promise.reject(err);
    });
}
export function uninstallCSS(urls) {
    urls.forEach(function (url) { return uninstallACSS(url); });
}
//# sourceMappingURL=data:application/json;base64,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